import { render } from "./FrenteCaixaDetalhePagamento.vue?vue&type=template&id=8afc7942&scoped=true&ts=true"
import script from "./FrenteCaixaDetalhePagamento.vue?vue&type=script&lang=ts"
export * from "./FrenteCaixaDetalhePagamento.vue?vue&type=script&lang=ts"

import "./FrenteCaixaDetalhePagamento.vue?vue&type=style&index=0&id=8afc7942&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8afc7942"]])

export default __exports__